import { _ } from '../../../helpers/src/lib/helpers';

export const PaymentMethodDict = {
    bank_transfer: _('CART|Bank transfer'),
    cash_on_delivery: _('CART|Cash on delivery'),
    heidelpay: _('CART|Unzer'),
    payu: _('CART|PayU'),
}
